// This file can be replaced during build by using the `fileReplacements` array.

// `ng build` replaces `environment.ts` with `environment.prod.ts`.

// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  clientID: "9e0d531f-a807-4b6b-946e-b01c756463ae",
  clientIDAPI: "93d78d64-9ab8-48e8-821d-739b84350238",
  authority: "https://diversitytraxai.b2clogin.com/diversitytraxai.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN",
  redirectURI: "https://10000001.suppliertrax.ai/dashboard",
  knownAuthorities: ["diversitytraxai.b2clogin.com"],
  logoutURI: "https://10000001.suppliertrax.ai/dashboard",
  loginFailedRoute: "/",
  b2cScopes: ["https://diversitytraxai.onmicrosoft.com/2d243dd9-e025-41d3-b142-ff2b125fa445/user_impersonation"],
  graphURL: "https://graph.microsoft-ppe.com/v1.0/me",
  graphScopes: ["user.read"],
  baseAppUrl: "https://10000001.suppliertrax.ai/",
  apiUrl: "https://11000002.suppliertrax.ai/api/",
  signUpAuthority: "https://diversitytraxai.b2clogin.com/diversitytraxai.onmicrosoft.com/B2C_1_DTraxAI-Email-SignUpOnly",//SignUp Userflow
  changePasswordAuthority: "https://diversitytraxai.b2clogin.com/diversitytraxai.onmicrosoft.com/B2C_1_PASSWORDCHANGE",//Password change Userflow
  Signupflow: "B2C_1_DTraxAI-Email-SignUpOnly",
  baseURL: "https://10000001.suppliertrax.ai/",
  templateBaseUrl: 'https://diversitytraxai.blob.core.windows.net/logos/DivTrax2.0/',
  logoImagePath: 'https://diversitytraxai.blob.core.windows.net/logos/DivTrax2.0/DiversityLogoPNG.png',
  azureBlobStorageName: "diversitytraxai",
  azureBlobStorageUrl: "https://diversitytraxai.blob.core.windows.net/",
  azureStorageContainer: "custom-ui"
};
